module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/transportation-banner.jpg",
            "altText": "Transportation worker"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Transportation Business Loans")]), _vm._v(" "), _c('p', [_vm._v("Transportation Business Financing & Equipment Loans")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering the Transportation Industry\n          everyday.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          You are constantly moving people or products from Point A to Point B\n          - There’s no time to waste. Businesses rely on you to get the job\n          done. However, life happens and issues arise such as mechanical\n          breakdowns, employee payroll issues, rising insurance rates, or\n          unexpected high fuel costs. That’s where we step in. American Credit\n          can help any financial emergency with immediate financing.\n          "), _c('br'), _c('br'), _vm._v("\n          Whether you transport goods via long haul trucking, or passengers\n          via commercial passenger transit, we understand your industry needs.\n          Read on and see how American Credit can help your business with a\n          commercial transportation loan.\n        ")])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row align-items-center logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/nefa-logo.png",
                  "alt": "NEFA logo"
                }
              })]), _vm._v(" "), _c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/transportation-equipment-loans.jpg",
            "altText": "Buses",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE",
            "ctaButtonTitle": "Apply For a Transportation Loan"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Instant Transportation Equipment Loans")]), _vm._v(" "), _c('p', [_vm._v("\n          Need to quickly expand your long haul fleet with brand new trucks?\n          Want to scale your commercial passenger transit business with a set\n          of new charter buses? Use your transportation equipment loan to\n          purchase trailers, semi-trucks, charter buses, freight-liners,\n          moving trucks, box trucks, sleeper trucks, limousines, and more!"), _c('br'), _c('br'), _vm._v("\n\n          American Credit understands the day-to-day difficulties the\n          transportation industry faces. We work with you to understand your\n          unique financial needs, and then secure quick funding so you can get\n          back to work.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/transportation-working-capital.jpg",
            "altText": "Transportation Worker"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Transportation Working Capital Solutions")]), _vm._v(" "), _c('p', [_vm._v("\n          You receive an immediate & lucrative order request that is too good\n          to turn down. Are you equipped financially to take on this sudden,\n          but important order? Do you have the manpower, fleet, and other\n          supplies or repair funds needed on such short notice? Keep in mind,\n          your response to this client could make or break your business for\n          years to come. "), _c('br'), _c('br'), _vm._v("\n\n          Let American Credit increase your financial budget with a working\n          capital loan for your transportation business, so you can fix any\n          sudden surprises asap.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems,
            "ctaButtonTitle": "Apply For a Transportation Loan"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Transportation Business Loan Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8d340b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/transportationBusinessLoans.vue
// module id = 2028
// module chunks = 5